
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined';
import CalendarViewWeekOutlinedIcon from '@mui/icons-material/CalendarViewWeekOutlined';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import InputIcon from '@mui/icons-material/Input';
import WarehouseIcon from '@mui/icons-material/Warehouse';

// carrierAlerts comes from the carrier stock alerts query, its total shows as a counter on the carriers tab
export const warehouseStockStockConfig = (carrierAlerts) => ({
    currentStock:  {
        title: 'stock',
        icon: <WarehouseIcon/>,
        isSingleDataGrid: true,
    },
    batches:  {
        title: 'batches',
        icon: <WarehouseIcon/>,
        isSingleDataGrid: true,
    },
    lots:  {
        title: 'lots',
        icon: <WarehouseIcon/>,
        isSingleDataGrid: true,
    },
    stockMutations:  {
        title: 'stock_mutations',
        icon: <WarehouseIcon/>,
        isSingleDataGrid: true,
    },
    abcAnalysis:  {
        title: 'abc_analysis',
        icon: <WarehouseIcon/>,
        isSingleDataGrid: true,
    },
    carriers:  {
        title: 'carriers',
        icon: <WarehouseIcon/>,
        isSingleDataGrid: true,
        countHelper: 'carriers_below_stock_level',
        ...(carrierAlerts && {count: carrierAlerts.total})
    }
});
